import React, { useEffect, useRef, useState } from 'react';
import Header from '../Component/Layout/Header';
import { MultiSelect } from 'react-multi-select-component';
import { CSVLink } from 'react-csv';
import AntDTable from './Common/AntDTable/AntDTable';
import { dataUser, getAmsToken } from '../Component/Helpers/util';
import axios from 'axios';
import moment from 'moment';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import Sidebar from './Layout/Sidebar';
import { Layout } from 'antd';
import CustomHeader from './Layout/Header';
import axiosInstance from '../utils/axiosInstance';
import RFIDExport from './CommonComponent/RFIDExport';
import SwSelect from './Common/SwReactSelect/SwReactSelect';
import SwMultiSelect from './Common/SwMultiSelect/SwMultiSelect';
import SwButton from './Common/SwButtons/SwButtons';
import AntDDatePicker from './Common/AntDDateTimePicker/AntDDatePicker';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

const RfidReport = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [appliedLocations, setAppliedLocations] = useState([]);
  const [spinner, setSpinner] = useState(false);

  const today = dayjs();
  const [startDate, setStartDate] = useState(today.startOf('month'));
  const [endDate, setEndDate] = useState(today);
  const [appliedStartDate, setAppliedStartDate] = useState(today.startOf('month'));
  const [appliedEndDate, setAppliedEndDate] = useState(today);
  const [showExportOffCanvas, setShowExportOffCanvas] = useState(false);
  const [accessType, setAccessType] = useState('All');
  const [appliedAccessType, setAppliedAccessType] = useState('All');
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [appliedDevices, setAppliedDevices] = useState([]);
  const [accessLogsData, setAccessLogsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const hasAppliedRef = useRef(false);


  const handleDeviceSelectionChange = selectedOptions => {
    if (selectedOptions.length > 0) {
      setSelectedDevices(selectedOptions.map(device => device.value));
    } else {
      setSelectedDevices([]);
    }
  };


  const toggleCollapsed = () => {
    setCollapsed(prevState => !prevState);
  };

 





  const columns = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: 'RFID',
    dataIndex: 'rfid',
    key: 'rfid',
  },
  {
    title: 'Location Name',
    key: 'location',
    render: (_, record) =>
      getLocationNameById(
        locations,
        record?.devideId?.location
      ),
  },
  {
    title: 'Time',
    dataIndex: 'time',
    key: 'time',
  },
  {
    title: 'Device Name',
    key: 'deviceName',
    render: (_, record) =>
      record?.devideId?.deviceName,
  },
];

  const fetchLocationsBySpoc = () => {
    const authToken = JSON.parse(localStorage.getItem('headData'));
    const headers = {
      Authorization: authToken?.spintlyToken,
      'Content-Type': 'application/json',
    };
    axios
      .get(`${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`, {
        params: { spoc: UserObj?.rec_id, client: UserObj?.company_id },
        headers,
      })
      .then(res => {
        if (res.data.status === 'success') {
          const formattedLocations = res?.data?.data?.map(location => ({
            label: location.location_name,
            value: location.rec_id,
          }));
          setLocations(formattedLocations);
          setSelectedLocations(formattedLocations); // Select all by default
        }
      })
      .catch(err => console.log('Error fetching locations:', err));
  };

  const getDeviceName = async () => {
    try {
      const selectedLocationIds = selectedLocations
        .map(loc => loc.value)
        .join(',');
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }access-control/v3/api/device/get-device-data?company_id=${UserObj.company_id
        }&location=${selectedLocationIds}&deviceFor=${accessType}`,
      );

      if (res.data.statusValue === 200) {
        const formattedDevices = res.data.data.map(device => ({
          label: device.deviceName,
          value: device._id,
        }));
        setDeviceOptions(formattedDevices);
        setSelectedDevices(formattedDevices.map(d => d.value));
      }
    } catch (error) {
      console.error('Error occurred while fetching device names:', error);
    }
  };

  const getAccessLogsData = async (page = currentPage) => {

    try {
      setSpinner(true);
      const limit = 25;
      const devicesToFetch = appliedDevices.length
        ? appliedDevices.join(',')
        : "";

      const res = await axiosInstance.get(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }access-control/v3/api/device/get-rfid-logs-csp?endTime=${appliedEndDate.format('YYYY-MM-DD')}&deviceId=${devicesToFetch}&page=${page}&limit=${limit}
        &startTime=${appliedStartDate.format('YYYY-MM-DD')}`,
      );

      if (res.data.statusValue === 200) {
        setAccessLogsData(res.data.data);
        setTotalPages(res.data.pagination.totalPages);
        setTotalRecords(res.data.pagination.totalRecords);
      }
    } catch (error) {
      console.error('Error occurred while fetching rfid logs:', error);
    } finally {
      setSpinner(false);
    }
  };

  useEffect(() => {
    if (selectedLocations.length && accessType) {
      getDeviceName();
    }
  }, [selectedLocations, accessType]);

  useEffect(() => {
    if (hasAppliedRef.current && appliedLocations.length && appliedDevices.length) {
      getAccessLogsData();
    }
  }, [
    currentPage,
    appliedLocations,
    appliedDevices,
    appliedAccessType,
    appliedStartDate,
    appliedEndDate,
  ]);

  const handleApply = () => {
    if (!startDate || !endDate) return;
    if (!selectedLocations.length) {
      toast.error('Please select at least one location');
      return;
    }
    if (!selectedDevices.length) {
      toast.error('Please select at least one device');
      return;
    }
    hasAppliedRef.current = true;
    setAppliedLocations(selectedLocations);
    setAppliedDevices(selectedDevices);
    setAppliedAccessType(accessType);
    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchLocationsBySpoc();
  }, []);

  const handleSelectionChange = selectedOptions => {
    setSelectedLocations(selectedOptions);
    setDeviceOptions([]);
    setSelectedDevices([]);
  };

  const handleAccessTypeChange = e => {
    setAccessType(e.target.value);
  };

  function getLocationNameById(locationData, locationId) {
    for (let i = 0; i < locationData.length; i++) {
      if (locationData[i].value == locationId) {
        return locationData[i].label;
      }
    }
    return '';
  }


  const handleExport = () => {
    const formattedData = accessLogsData && accessLogsData?.map(item => ({
      date: item?.date,
      rfid: item.rfid,
      location: getLocationNameById(
        locations,
        item?.devideId?.location,
      ),
      time: item?.time,
      deviceName: item?.devideId?.deviceName
    }));

    const headers = [
      { label: 'Date', key: 'date' },
      { label: 'RFID', key: 'rfid' },
      { label: 'Location', key: 'location' },
      { label: 'Time', key: 'time' },
      { label: 'Device Name', key: 'deviceName' }


    ];

    return { data: formattedData, headers, filename: 'RFID Logs.csv' };
  };

  const accessTypeOptions = [
    { value: "All", label: "All" },
    { value: "Building", label: "Building" },
    { value: "Company", label: "Company" },
  ];

  return (
    <>
      <RFIDExport show={showExportOffCanvas} onClose={() => setShowExportOffCanvas(false)} />
      <Layout>
        <Sidebar collapsed={collapsed} />
        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
        <Layout
          className={
            collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'
          }
        >
          <div className="PageContent">
            <div className="row">
              <div className="col-md-12 ">

                <div className='row '>
                  <div className='col-md-6'>
                    <div className="SwHeading">
                      <h2>RFID Logs</h2>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className="PageHead_Optons_Row">
                      <ul className='PageHead_Optons_RightAligned'>
                        <li >
                          <SwButton
                            onClick={() => setShowExportOffCanvas(true)}
                            variant="dark" size="sm"
                            icon={<i class="bi bi-box-arrow-right"></i>}
                            iconPosition='start'
                          >
                            Export RFID Logs
                          </SwButton>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>


                <div className="row align-items-end">
                  <div className="col-lg-2">
                    <div className="SwFormGroup">
                      <label className="SwFormLabel">Location</label>
                      <SwMultiSelect
                        options={locations}
                        value={selectedLocations}
                        onChange={handleSelectionChange}
                        label="Select"
                      />
                    </div>
                  </div>

                  <div className="col-lg-2">
                    <div className="SwFormGroup">
                      <label className="SwFormLabel">Start Date</label>
                      <AntDDatePicker
                        value={startDate}
                        format="DD/MM/YYYY"
                        allowClear={false}
                        disabledDate={(current) => {
                          if (!current) return false;
                          const minDate = dayjs().subtract(3, 'month').startOf('month');
                          const maxDate = dayjs().endOf('day');
                          return current.isBefore(minDate) || current.isAfter(maxDate);
                        }}
                        onChange={(date) => {
                          if (!date) return;
                          setStartDate(date);
                          if (
                            endDate &&
                            (endDate.isBefore(date, 'day') ||
                              endDate.month() !== date.month() ||
                              endDate.year() !== date.year())
                          ) {
                            setEndDate(date);
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-lg-2">
                    <div className="SwFormGroup">
                      <label className="SwFormLabel">End Date</label>
                      <AntDDatePicker
                        value={endDate}
                        format="DD/MM/YYYY"
                        allowClear={false}
                        disabledDate={(current) => {
                          if (!current) return false;
                          const minDate = dayjs().subtract(3, 'month').startOf('month');
                          const maxDate = dayjs().endOf('day');
                          if (current.isBefore(minDate) || current.isAfter(maxDate)) return true;
                          if (startDate) {
                            if (current.isBefore(startDate, 'day')) return true;
                            if (current.month() !== startDate.month() || current.year() !== startDate.year()) return true;
                          }
                          return false;
                        }}
                        onChange={(date) => {
                          if (date && (date.isSame(startDate, 'day') || date.isAfter(startDate, 'day'))) {
                            setEndDate(date);
                          } else {
                            toast.error(
                              'End date should be greater than or equal to start date',
                              {},
                            );
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-lg-2">
                    <div className="SwFormGroup">
                      <label className='SwFormLabel'>Access Type</label>
                      <SwSelect
                        options={accessTypeOptions}
                        placeholder='Select Access type'
                        isClearable={false}
                        value={accessTypeOptions.find(
                          opt => opt.value === accessType
                        )}
                        onChange={(selectedOption) => {
                          handleAccessTypeChange({
                            target: {
                              value: selectedOption ? selectedOption.value : "All",
                            },
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-lg-2">
                    <div className="SwFormGroup">
                      <label className='SwFormLabel'>Device Name</label>
                      <SwMultiSelect
                        options={deviceOptions}
                        value={deviceOptions.filter(device =>
                          selectedDevices.includes(device.value)
                        )}
                        onChange={handleDeviceSelectionChange}
                        label="DeviceName"
                      />
                    </div>
                  </div>

                  <div className="col-lg-2">
                    <div className="SwFormGroup">
                      <label className='SwFormLabel invisible'>Apply</label>
                      <SwButton
                        type='button'
                        variant='primary'
                        size='sm'
                        onClick={handleApply}
                        disabled={!startDate || !endDate}
                        loading={spinner}
                      >
                        Apply
                      </SwButton>
                    </div>
                  </div>
                </div>

                {/* Card end */}
                <div className="row mt-4">
                  <div className="col-12">
                    <div className="">
                      
                        <AntDTable
                          columns={columns}
                          dataSource={accessLogsData}
                          rowKey="_id"
                          loading={spinner}
                          pagination
                          currentPage={currentPage}
                          pageSize={25}
                          totalRecords={totalRecords}
                          onPageChange={(page, size) => {
                            setCurrentPage(page);
                          }}
                          showTotal
                        />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Layout>
      </Layout>
    </>
  );
};

export default RfidReport;

